import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ReportePagosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reporte-pagos',
  templateUrl: 'reporte-pagos.html',
})
export class ReportePagosPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/reporte-pagos/reporte-pagos.ts